import { OpportunitySkillFields } from '../OpportunitySkillFields.fragment';
import { graphql } from 'GQL/gql';

const CompanyOpportunitySkillsTypeFields = graphql(`
  ${OpportunitySkillFields}
  fragment CompanyOpportunitySkillsTypeFields on CompanyOpportunitySkillsType {
    __typename
    mostRelevant {
      ...OpportunitySkillFields
    }
    relevant {
      ...OpportunitySkillFields
    }
  }
`);
CompanyOpportunitySkillsTypeFields.mainFragmentName = 'CompanyOpportunitySkillsTypeFields';

const CompanyOpportunityFields = graphql(`
  fragment CompanyOpportunityFields on CompanyOpportunity {
    __typename
    _id
    job {
      _id
      name
      trendIcon
    }
    covered
    follow
    isAnonymous
    link
  }
`);
CompanyOpportunityFields.mainFragmentName = 'CompanyOpportunityFields';

const CompanyOpportunityDetailsFields = graphql(`
  ${OpportunitySkillFields}
  ${CompanyOpportunitySkillsTypeFields}
  fragment CompanyOpportunityDetailsFields on CompanyOpportunity {
    __typename
    _id
    isAnonymous
    description
    matching {
      ...CompanyOpportunitySkillsTypeFields
      related {
        ...OpportunitySkillFields
      }
    }
    missing {
      ...CompanyOpportunitySkillsTypeFields
    }
  }
`);
CompanyOpportunityDetailsFields.mainFragmentName = 'CompanyOpportunityDetailsFields';

export {
  CompanyOpportunityDetailsFields,
  CompanyOpportunityFields,
  CompanyOpportunitySkillsTypeFields,
};
